<!-- eslint-disable -->
<template>
  <div class="formkit-simple-html">
    <div ref="html" class="formkit-simple-html__content" v-html="content" />
    <Teleport v-if="isReady && teleport && tooltip" :to="teleport">
      <InfoTooltip :content="tooltip" />
    </Teleport>
    <InfoTooltip v-else-if="isReady && tooltip" :content="tooltip" />
  </div>
</template>

<script src="./SimpleHTML.js"></script>
<!-- eslint-enable -->
